import * as React from "react";

import S from "./styles";

const Loader: React.FC<{ full?: boolean }> = ({ full }) => {
  const getHeight = () => {
    const headerHeight =
      document.getElementById("header") &&
      document?.getElementById("header")?.offsetHeight;
    const footerHeight =
      document.getElementById("footer") &&
      document?.getElementById("footer")?.offsetHeight;
    return window.innerHeight - headerHeight - footerHeight;
  };

  return (
    <S.Loader style={full && { height: getHeight() }}>
      <div className="loader__items">
        <span />
        <span />
        <span />
      </div>
    </S.Loader>
  );
};

export default Loader;
